var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('selector',{attrs:{"items":_vm.items,"full":true,"current":_vm.currentItem.label},on:{"change":_vm.updateCurrentItem}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }